import BodyBackground from "@/common/components/body-background";
import ScrollToTop from "@/common/components/scroll-to-top";
import Footer from "@/common/containers/footer";
import NavigationBar from "@/common/containers/navigation-bar";
import ErrorBoundary from "@/components/error-boundary";
import { CartProvider } from "@/features/merch/providers/cart";
import { SubscriptionProvider } from "@/features/payments/providers/subscription";
import { Outlet } from "react-router-dom";

export default function LayoutPage() {
	return (
		<ErrorBoundary>
			<BodyBackground />
			<ScrollToTop />
			<SubscriptionProvider>
				<CartProvider>
					<NavigationBar />
					<Outlet />
					<Footer />
				</CartProvider>
			</SubscriptionProvider>
		</ErrorBoundary>
	);
}
